/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Base loan information
 * @export
 * @interface LoanBaseDto
 */
export interface LoanBaseDto {
    /**
     * Unique loan identifier
     * @type {string}
     * @memberof LoanBaseDto
     */
    id: string;
    /**
     * Loan amount in currency
     * @type {number}
     * @memberof LoanBaseDto
     */
    loanAmount: number;
    /**
     * Total loan duration in months
     * @type {number}
     * @memberof LoanBaseDto
     */
    totalDuration: number;
    /**
     * Interest rate type identifier
     * @type {string}
     * @memberof LoanBaseDto
     */
    interestRateTypeId: string;
    /**
     * Interest rate percentage
     * @type {number}
     * @memberof LoanBaseDto
     */
    interestRatePercentage: number;
    /**
     * Deferment type identifier
     * @type {string}
     * @memberof LoanBaseDto
     */
    defermentTypeId: string;
    /**
     * Deferred period in months
     * @type {number}
     * @memberof LoanBaseDto
     */
    defermentPeriod: number;
    /**
     * Loan type identifier
     * @type {string}
     * @memberof LoanBaseDto
     */
    loanTypeId: string;
    /**
     * Insurance amount (optional)
     * @type {number}
     * @memberof LoanBaseDto
     */
    insuranceAmount?: number | null;
}

/**
 * Check if a given object implements the LoanBaseDto interface.
 */
export function instanceOfLoanBaseDto(value: object): value is LoanBaseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('loanAmount' in value) || value['loanAmount'] === undefined) return false;
    if (!('totalDuration' in value) || value['totalDuration'] === undefined) return false;
    if (!('interestRateTypeId' in value) || value['interestRateTypeId'] === undefined) return false;
    if (!('interestRatePercentage' in value) || value['interestRatePercentage'] === undefined) return false;
    if (!('defermentTypeId' in value) || value['defermentTypeId'] === undefined) return false;
    if (!('defermentPeriod' in value) || value['defermentPeriod'] === undefined) return false;
    if (!('loanTypeId' in value) || value['loanTypeId'] === undefined) return false;
    return true;
}

export function LoanBaseDtoFromJSON(json: any): LoanBaseDto {
    return LoanBaseDtoFromJSONTyped(json, false);
}

export function LoanBaseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoanBaseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'loanAmount': json['loanAmount'],
        'totalDuration': json['totalDuration'],
        'interestRateTypeId': json['interestRateTypeId'],
        'interestRatePercentage': json['interestRatePercentage'],
        'defermentTypeId': json['defermentTypeId'],
        'defermentPeriod': json['defermentPeriod'],
        'loanTypeId': json['loanTypeId'],
        'insuranceAmount': json['insuranceAmount'] == null ? undefined : json['insuranceAmount'],
    };
}

export function LoanBaseDtoToJSON(json: any): LoanBaseDto {
    return LoanBaseDtoToJSONTyped(json, false);
}

export function LoanBaseDtoToJSONTyped(value?: LoanBaseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'loanAmount': value['loanAmount'],
        'totalDuration': value['totalDuration'],
        'interestRateTypeId': value['interestRateTypeId'],
        'interestRatePercentage': value['interestRatePercentage'],
        'defermentTypeId': value['defermentTypeId'],
        'defermentPeriod': value['defermentPeriod'],
        'loanTypeId': value['loanTypeId'],
        'insuranceAmount': value['insuranceAmount'],
    };
}

